const PAGE_LIFECYCLE_SINGLETON_EVENT_TYPES = new Set(["diagnostic"]);

export function isPageLifecycleSingletonEvent(type: string) {
  return PAGE_LIFECYCLE_SINGLETON_EVENT_TYPES.has(type);
}

export function createPageLifecycleEventGate() {
  const emitted = new Set<string>();

  return {
    shouldTrack(type: string, siteKey = "default") {
      if (!isPageLifecycleSingletonEvent(type)) return true;

      const key = `${siteKey || "default"}:${type}`;
      if (emitted.has(key)) return false;

      emitted.add(key);
      return true;
    },
  };
}
